import { render, staticRenderFns } from "./exportCartonStorageFee.vue?vue&type=template&id=3a65bcce&scoped=true"
import script from "./exportCartonStorageFee.vue?vue&type=script&lang=js"
export * from "./exportCartonStorageFee.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "3a65bcce",
  null
  
)

export default component.exports